<div class="page-wrapper form-wrapper">
  <section class="article-page-title" *ngIf="title">
    <div class="wrapper">
      <h1 class="heading">{{ title }}</h1>
    </div>
  </section>
  <ng-container #bodyAnchor></ng-container>
</div>
